import _extends from "babel-runtime/helpers/extends";

export default {
  props: {
    formValue: {
      type: Object,
      required: true
    },

    config: {
      type: Object,
      required: true
    },

    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  computed: {
    innerConfig: function innerConfig() {
      var params = _extends({}, this.config.params);
      if (this.options.length > 0) {
        params.options = this.options;
      }
      return _extends({}, this.config, {
        params: params
      });
    }
  }
};